module.exports = __webpack_public_path__ + "static/media/login_al_5.7aa0599f.png";